import { React } from 'react';
import ServiceSection from '../../../../ServiceSection/ServiceSection';
import SatelliteText from '../../../SatelliteText/SatelliteText';
import SatelliteTopics from '../../../SatelliteTopics/SatelliteTopics';
import satelliteIcon from '../../../satelliteIcon';

const CostNoItSupport6 = props => (
    <ServiceSection noPadTitle singleTitle icon={satelliteIcon} {...props} page="costNoItSupport" section="proactive">
        <div className='TextGroup Satellite'>
            <SatelliteTopics t={props.t} prefix="costNoItSupport:proactive" noGroupTitle tag="h3" first />
            <div className='container-custom subtitle'>
                <SatelliteText t={props.t} prefix="costNoItSupport:proactive.closing" noPadBottom />
            </div>
        </div>
    </ServiceSection>
);

export default CostNoItSupport6;
